import { render, staticRenderFns } from "./ResultLogButton.vue?vue&type=template&id=84612f28&scoped=true&"
import script from "./ResultLogButton.vue?vue&type=script&lang=js&"
export * from "./ResultLogButton.vue?vue&type=script&lang=js&"
import style0 from "./ResultLogButton.vue?vue&type=style&index=0&id=84612f28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84612f28",
  null
  
)

export default component.exports